export default __webpack_public_path__ + "static/logo-seoul-medical-center-585fe3f5bd29f2e5938328bcdea252a2.png";